export default "__VITE_ASSET__BJHF_XW7__"